import { useState } from 'react'
import { Platform } from 'react-native'

import { FormattedMessage } from 'react-intl'

import Text, { TextProps } from '../base/Text'

interface ShowMoreTextProps {
  text: string
  showMoreLabel?: string | React.ReactNode
  showLessLabel?: string | React.ReactNode
  cuttingCount?: number
  textProps?: TextProps
}

const ShowMoreText: RFC<ShowMoreTextProps> = ({
  text,
  showMoreLabel = <FormattedMessage defaultMessage="Show More" />,
  showLessLabel = <FormattedMessage defaultMessage="Show Less" />,
  cuttingCount = 400,
  textProps
}) => {
  const [showMore, setShowMore] = useState(false)

  const isLongText = text?.length > cuttingCount

  const formatText = (text: string, cuttingCount: number) => {
    return isLongText ? `${text?.substring(0, cuttingCount)}...` : text
  }

  const displayedText = showMore ? text : formatText(text, cuttingCount)

  return (
    <>
      <Text {...textProps}>
        {displayedText}{' '}
        {isLongText && (
          <Text
            sx={{
              fontWeight: 500,
              ...Platform.select({
                web: {
                  display: ' inline-flex',
                  cursor: 'pointer',
                  '&:hover': {
                    color: 'secondary.dark'
                  }
                }
              })
            }}
            variant="body2"
            onClick={() => setShowMore((prev) => !prev)}
          >
            {showMore ? showLessLabel : showMoreLabel}
          </Text>
        )}
      </Text>
    </>
  )
}

export default ShowMoreText
